import { useDisclosure } from "@chakra-ui/hooks";
import { Popover, PopoverContent, PopoverTrigger } from "@chakra-ui/react";
import { ActivityVisuel } from "domain/entities/activities.entities";
import { HiDownload } from "react-icons/hi";

export function Visual({ visual }: { visual: ActivityVisuel }) {
  const popoverState = useDisclosure();

  const handleDownloadClick = async (e: any, type: "pdf" | "png") => {
    e.stopPropagation();
    if (visual[type]) {
      window.open(visual[type], "_blank").focus();
    }
  };

  return (
    <Popover
      isOpen={popoverState.isOpen}
      onOpen={popoverState.onOpen}
      onClose={popoverState.onClose}
      placement="bottom-end"
    >
      <PopoverTrigger>
        <button
          onClick={(e) => {
            e.stopPropagation();
          }}
          className={`flex w-fit items-center rounded-xl px-4 py-3 font-semibold text-secondaryGrey-900 ${
            popoverState.isOpen ? "bg-darkGrey-300" : "bg-darkGrey-200"
          }`}
        >
          <span className="me-4 text-xs">{visual.title}</span>
          <span className="w-4">
            <HiDownload size={16} />
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent
        style={{
          isolation: "isolate",
          zIndex: 100,
          width: "fit-content",
          border: "none",
          backgroundColor: "transparent",
          boxShadow: "none",
        }}
      >
        <div className="flex flex-col rounded-[20px] bg-white px-2 py-3 text-sm font-semibold text-darkGrey-700 shadow-lg">
          <button
            className="flex rounded-[10px] px-3 py-2 hover:bg-darkGrey-100"
            onClick={(e) => handleDownloadClick(e, "pdf")}
          >
            <HiDownload className="me-2 text-secondaryGrey-900" size={20} />
            Pdf
          </button>
          <button
            className="flex rounded-[10px] px-3 py-2 hover:bg-darkGrey-100"
            onClick={(e) => handleDownloadClick(e, "png")}
          >
            <HiDownload className="me-2 text-secondaryGrey-900" size={20} />
            Png
          </button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
